import countries from './countries';

const country = countries[process.env.GATSBY_COUNTRY_CODE];

const supportedLanguages = ['pl', 'de-CH', 'de-AT', 'en-GB'];
export const isDRSmileInactive = supportedLanguages.includes(country.lang);
